export const CONFIG = {
  autoParseDelay: 350,
  toastDuration: 1800,
  minPaneSize: 160,
};
